import {DOCUMENT_CHECK_URL} from "../common/constants";
import ExpandableROList from "../common/ExpandableROList";
import GliderDocumentCheck from "./GliderDocumentCheck";

export const GliderDocumentCheckList = ExpandableROList(GliderDocumentCheck, DOCUMENT_CHECK_URL, "gliderDocumentCheck", null, );

